<template>
  <div class="home">
    <p>欢迎使用{{profile?.nickname}}</p>
  </div>
</template>

<script>
// @ is an alias to /src

import axios from "@/utils/axios";
import config from "@/config";

export default {
  name: 'HomeView',
  data() {
    return {
      profile: false
    }
  },
  mounted() {
    console.log('mounted')
    this.fetchProfile()

  },
  methods: {
    async fetchProfile() {
      console.log('fetch profile')
      const url = `${config.API_BASE_URL}/api/user/profile`
      try {
        const response = await axios.get(url);
        console.log(response.data);
        if (response.data.status === 'success') {
          this.profile = response.data.data;
          window.location.href = '/customer'
        } else {
          window.location.href = '/login'
        }
      } catch (err) {
        this.error = 'Failed to load data: ' + err.message;
      }
    }

  }
}
</script>
